export default function ButtonSecondary({label,clickEvent}){

    return(
        <div className="modal-btn-secondary" onClick={clickEvent}>{label}</div>
    )
    
}